import { useDealForecastStore } from '@openx/components-deal/lib/utils/context/DealForecastContext/DealForecastProvider.tsx';
import type { UseDealForecast } from '@openx/components-deal/lib/utils/context/DealHookTypes.ts';

import { useDealForecastActions } from './useDealForecastActions.ts';

export const useDealForecast: UseDealForecast = () => {
  const { state } = useDealForecastStore();
  const actions = useDealForecastActions();

  return {
    actions,
    forecastState: {
      audience_monthly_requests: state.audience_monthly_requests,
      contextual_estimate: state.contextual_estimate,
      deal_participants: state.deal_participants,
      disabled: state.disabled,
      error: state.error,
      forecast: state.forecast,
      job_id: state.job_id,
      loading: state.loading,
      not_included_fields: state.not_included_fields,
      package_loading: state.package_loading,
    },
  };
};
